export const FETCH_WEBHOOKS = 'line-up/webhooks/FETCH_WEBHOOKS';
export const FETCH_WEBHOOK_TYPES = 'line-up/webhooks/FETCH_WEBHOOK_TYPES';
export const CREATE_WEBHOOK = 'line-up/webhooks/CREATE_WEBHOOK';
export const UPDATE_WEBHOOK = 'line-up/webhooks/UPDATE_WEBHOOK';
export const DELETE_WEBHOOK = 'line-up/webhooks/DELETE_WEBHOOK';
export const FETCH_WEBHOOK = 'line-up/webhooks/FETCH_WEBHOOK';
